<div class="dialog-container">
  <div class="dialog-header">
    <h2>Airbnb Opportunities</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-spinner *ngIf="loading" diameter="40" class="spinner"></mat-spinner>

  <ng-container *ngIf="!loading">
    <!-- List View -->
    <ng-container *ngIf="currentView === OpportunityView.LIST">
      <div class="dialog-content">
        <div *ngIf="opportunities.length === 0" class="flex flex-col items-center text-center mt-8">
          <mat-icon class="text-night-lighter mb-4" style="font-size: 48px; width: 48px; height: 48px;">lightbulb_outline</mat-icon>
          <h3 class="mb-2">No opportunities found</h3>
          <p class="text-night-lighter">We couldn't find any opportunities for this property at the moment. Check back later for new recommendations.</p>
          <sbnb-button class="mt-4" type="secondary" (click)="close()">Close</sbnb-button>
        </div>

        <ng-container *ngIf="opportunities.length > 0">
          <p class="description">
            Discover and apply opportunities based on what guests are searching for on Airbnb. These recommendations could help improve your booking performance.
          </p>

          <div class="opportunities-list">
            <div *ngFor="let opportunity of opportunities" class="opportunity-item" (click)="showOpportunityDetails(opportunity)">
              <div class="opportunity-content">
                <h3>{{ opportunity.title }}</h3>
                <p>{{ opportunity.description }}</p>
              </div>
              <mat-icon>chevron_right</mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <!-- Details View -->
    <ng-container *ngIf="currentView === OpportunityView.DETAILS">
      <div class="details-wrapper">
        <div class="dialog-content details-content" *ngIf="selectedOpportunity">
          <h3>{{ selectedOpportunity.title }}</h3>
          <p class="description">{{ selectedOpportunity.description }}</p>
        </div>

        <div class="action-buttons">
          <sbnb-button type="secondary" (click)="currentView = OpportunityView.LIST">Cancel</sbnb-button>
          <sbnb-button type="primary" (click)="applyOpportunity()">Apply</sbnb-button>
        </div>
      </div>
    </ng-container>

    <!-- Success View -->
    <ng-container *ngIf="currentView === OpportunityView.SUCCESS">
      <div class="dialog-content success-content">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Opportunity Applied!</h3>
        <p>The opportunity has been successfully applied to your listings.</p>
      </div>

      <div class="action-buttons flex flex-col items-center gap-4">
        <sbnb-button type="primary" (click)="applyMore()">Apply more opportunities</sbnb-button>
        <sbnb-button type="secondary" (click)="close()">I'm finished</sbnb-button>
      </div>
    </ng-container>
  </ng-container>
</div>
